import { Box } from "@mui/material";
import PropTypes from "prop-types";

function PhonePreview({
  iframeSrc,
  image,
  width = 375,
  aspectRatio = 812 / 375, // Default to iPhone aspect ratio
  backgroundColor = "black",
}) {
  const height = width * aspectRatio;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Box
        sx={{
          width,
          height,
          borderRadius: "40px",
          border: "10px solid black",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
          overflow: "hidden",
          position: "relative",
          backgroundColor,
        }}
      >
        {iframeSrc ? (
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            title="App Preview"
            style={{
              border: "none",
              borderRadius: "30px",
            }}
          />
        ) : (
          <img
            src={image}
            alt="App Screenshot"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover", // 👈 safer than "cover" for full visibility
              borderRadius: "30px",
            }}
          />
        )}

        {/* Notch */}
        <Box
          sx={{
            position: "absolute",
            top: "5px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "150px",
            height: "8px",
            backgroundColor: "black",
            borderRadius: "10px",
          }}
        />
      </Box>
    </Box>
  );
}

PhonePreview.propTypes = {
  iframeSrc: PropTypes.string,
  image: PropTypes.string,
  width: PropTypes.number,
  aspectRatio: PropTypes.number,
  backgroundColor: PropTypes.string,
};

export default PhonePreview;
